
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'expandable-entity',
    components: {},
    props: { availableEntities: { type: Array } },
    emits: ['close'],
    data() {
        return {
            entities: [] as any,
            colors: ['#D7263D', '#F46036', '#2E294E', '#1B998B', '#C5D86D', '#3F51B5', '#8BC34A', '#009688', '#F44336']
        }
    },
    watch: {
        availableEntities() {
            this.entities = this.availableEntities
        }
    },
    created() {
        this.entities = this.availableEntities
    },
    methods: {
        expandEntity(entity) {
            entity.expanded = !entity.expanded
        },
        getIconCls(iconCls) {
            switch (iconCls) {
                case 'measure':
                    return 'fas fa-ruler'
                case 'cube':
                    return 'fas fa-cube'
                case 'calculation':
                    return 'fas fa-calculator'
                case 'dimension':
                    return 'fas fa-ruler-horizontal'
                case 'geographic dimension':
                    return 'fas fa-map-marked-alt'
                case 'attribute':
                    return 'fas fa-font'
                case 'generic':
                    return 'fas fa-layer-group'
                default:
                    return 'fas fa-cube'
            }
        },
        onDragStart(event, entity) {
            event.dataTransfer.setData('text', JSON.stringify(entity))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
        }
    }
})
